module.exports = __webpack_public_path__ + "img/warning-alert-icon.df74c74d.svg";